import type { AccountMovement } from '@ergo/shared';

/**
 * Ce que le relevé montre d'emblée : les factures que les paiements n'ont pas encore
 * couvertes. Les paiements ne sont jamais affectés à une facture — on les laisse
 * simplement « couvrir » les factures de la plus ancienne à la plus récente, pour
 * l'affichage seulement. Une facture entièrement couverte rejoint l'historique, avec
 * tous les paiements ; une facture partiellement couverte reste visible, comme le
 * solde qui dit ce qui manque.
 */
export function splitReleve(releve: AccountMovement[]): {
  open: AccountMovement[];
  history: AccountMovement[];
} {
  let credit = releve
    .filter((m) => m.kind === 'payment')
    .reduce((sum, m) => sum + Math.round(m.amountEur * 100), 0);

  const covered = new Set<number>();
  const oldestFirst = [...releve]
    .filter((m) => m.kind === 'note')
    .sort((a, b) => a.date.localeCompare(b.date) || a.id - b.id);
  for (const note of oldestFirst) {
    const due = Math.round(-note.amountEur * 100);
    if (due <= credit) {
      credit -= due;
      covered.add(note.id);
    } else {
      break;
    }
  }

  const open = releve.filter((m) => m.kind === 'note' && !covered.has(m.id));
  const history = releve.filter((m) => !(m.kind === 'note' && !covered.has(m.id)));
  return { open, history };
}
